//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setDefaultWidths, loadTableSettings, sendTableSettings } from './TableColumnWidths.js'
import draggable from 'vuedraggable'

function arrayMove (array, oldIndex, newIndex) {
  while (oldIndex < 0) {
    oldIndex += array.length
  }
  while (newIndex < 0) {
    newIndex += array.length
  }

  if (newIndex >= array.length) {
    let k = newIndex - array.length + 1
    while (k--) {
      array.push(undefined)
    }
  }

  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0])
}

export default {
  components: {
    draggable
  },
  props: {
    defaultColumns: {
      type: Array,
      default () {
        return []
      }
    },
    tableName: {
      type: String,
      default: null
    },
    folder: {
      type: String,
      default: 'delta-table-config'
    },
    useGroups: {
      type: Boolean,
      default: false
    },
    groupsNames: {
      type: Array,
      default () {
        return []
      }
    },
    groupPropertyKey: {
      type: String,
      default: 'sheetName'
    }
  },
  data: function () {
    return {
      loading: false,
      columnsLocal: [],
      escPressed: false,
      dragEscaped: false,
      showOnlyActive: false,
      columnSearchValue: null,
      selectedGroup: this.useGroups ? this.groupsNames[0] : null
    }
  },
  computed: {
    mainCheckbox: function () {
      const activeColumnsCount = this.columnsLocal.reduce((count, column) => count + ((!this.useGroups || column[this.groupPropertyKey] === this.selectedGroup) && column.active ? 1 : 0), 0)
      const alwaysActiveColumnsCount = this.columnsLocal.reduce((count, column) => count + ((!this.useGroups || column[this.groupPropertyKey] === this.selectedGroup) && column.alwaysActive ? 1 : 0), 0)
      if (activeColumnsCount === this.columnsLocal.filter(column => !this.useGroups || column[this.groupPropertyKey] === this.selectedGroup).length) {
        return true
      } else if (activeColumnsCount === alwaysActiveColumnsCount) {
        return false
      }
      return null
    },
    foundColumnsCount: function () {
      return this.columnsLocal.filter(column => this.isColumnVisible(column)).length
    }
  },
  created: function () {
    this.loading = true
    this.loadTableSettings()
      .then(response => {
        this.prepareTableSettings(response)
      })
      .finally(() => {
        this.loading = false
      })
    this.setGlobalListeners()
  },
  beforeDestroy: function () {
    this.removeGlobalListeners()
  },
  methods: {
    setGlobalListeners: function () {
      document.addEventListener('keydown', this.escDownListener)
      document.addEventListener('keyup', this.escUpListener)
    },
    removeGlobalListeners: function () {
      document.removeEventListener('keydown', this.escDownListener)
      document.removeEventListener('keyup', this.escUpListener)
    },
    isColumnVisible: function (column) {
      const matchesGroup = !this.useGroups || column[this.groupPropertyKey] === this.selectedGroup
      const matchesActive = !this.showOnlyActive || column.active
      const matchesSearch = (column.label || '').toLowerCase()
        .includes((this.columnSearchValue || '').toLowerCase())
      return matchesGroup && matchesActive && matchesSearch
    },
    onMainCheckbox: function () {
      const value = this.mainCheckbox
      for (const column of this.columnsLocal) {
        if (!column.alwaysActive && (!this.useGroups || column[this.groupPropertyKey] === this.selectedGroup)) {
          column.active = !value
        }
      }
    },
    onApplyDefaultSettings: function () {
      this.selectedColumnIndex = null
      this.resetColumns()
      setDefaultWidths(this.defaultColumns, this.tableName, this.$store)
    },
    onCloseTableSettings: function () {
      for (const column of this.defaultColumns) {
        column.new = false
      }
      this.$emit('close')
    },
    onSaveTableSettings: function () {
      if (!this.columnsLocal.find(column => column.active)) {
        this.$q.notify({
          type: 'negative',
          message: 'Хотя бы один столбец должен быть активным',
          progress: true,
          timeout: 8000
        })
        return
      }

      this.loading = true
      return sendTableSettings(this.tableName, {
        order: this.columnsLocal.map(column => column.name),
        hidden: this.columnsLocal.filter(column => !column.active).map(column => column.name)
      }, this.folder)
        .then(() => {
          this.$q.notify({
            type: 'positive',
            message: 'Настройки таблицы сохранены',
            progress: true,
            timeout: 3000
          })

          this.$emit('save')
        })
        .finally(this.loading = false)
    },
    loadTableSettings: function () {
      return loadTableSettings(this.tableName, this.folder)
    },
    prepareTableSettings: function (tableSettings) {
      if (tableSettings == null || tableSettings.hidden == null || tableSettings.order == null) {
        this.resetColumns()
      } else {
        const columnsHidden = [...new Set(JSON.parse(tableSettings.hidden))]
        const columnsOrder = [...new Set(JSON.parse(tableSettings.order))]

        let orderedColumns = []
        for (const columnName of columnsOrder) {
          const column = this.defaultColumns.find(column => column.name === columnName)
          if (column) {
            orderedColumns.push(column)
          }
        }
        orderedColumns = orderedColumns.map(column => ({
          ...column,
          active: !columnsHidden.includes(column.name)
        }))

        let hasNewColumns = false
        for (let i = 0; i < this.defaultColumns.length; i++) {
          const column = this.defaultColumns[i]
          if (column.new) {
            if (i === 0) {
              orderedColumns.unshift(column)
            } else {
              const previousColumn = this.defaultColumns[i - 1]
              orderedColumns.splice(orderedColumns.indexOf(previousColumn) + 1, 0, column)
            }
            this.$set(column, 'active', false)
            hasNewColumns = true
          }
        }

        if (orderedColumns.length < this.defaultColumns.length) {
          this.resetColumns() // TODO
        } else {
          this.columnsLocal = orderedColumns
        }

        if (hasNewColumns) {
          sendTableSettings(this.tableName, {
            order: this.columnsLocal.map(column => column.name),
            hidden: this.columnsLocal.filter(column => !column.active).map(column => column.name)
          }, this.folder)
        }
      }
    },
    resetColumns: function () {
      this.columnsLocal = this.defaultColumns.map(column => ({
        ...column,
        active: column.active === undefined ? true : !!column.active
      }))
    },
    cancelDrag: function (evt) {
      if (this.dragEscaped) {
        arrayMove(this.columnsLocal, evt.newIndex, evt.oldIndex)
        this.dragEscaped = false
      }
    },
    onDragEnd: function (evt) {
      setTimeout(this.cancelDrag, 100, evt)
    },
    escUpListener: function (e) {
      if (e.code === 'Escape' && !this.escPressed) {
        this.dragEscaped = true
      }
      if (this.escPressed) {
        this.escPressed = false
      }
    },
    escDownListener: function (e) {
      if (e.code === 'Escape') {
        this.escPressed = true
      }
    },
    onMoveUp: function (column) {
      if (this.columnsLocal.indexOf(column) > 0) {
        const index = this.columnsLocal.indexOf(column)
        arrayMove(this.columnsLocal, index, 0)
      }
    }
  }
}
